// extracted by mini-css-extract-plugin
export var galleryContainer = "galleries-module--galleryContainer--a6032";
export var galleryFullContainer = "galleries-module--galleryFullContainer--29bd4";
export var galleryPageContainer = "galleries-module--galleryPageContainer--afe4c";